module.exports = "/_next/static/images/995096d33746164a160464415184fe07-mgm-xs-2.png.webp";